import { createAction } from '@af-common/Common/_actions/Action';

export enum ToolsActionType {
	OnToggleGrid          	= 'TOOLS_TOGGLE_GRID',
	OnToggleRulers        	= 'TOOLS_TOGGLE_RULERS',
	OnToggleOverlay       	= 'TOOLS_TOGGLE_OVERLAY',
	OnCenterDocument      	= 'TOOLS_CENTER_DOCUMENT',
	OnTogglePreviewFabric 	= 'TOOLS_TOGGLE_PREVIEW_FABRIC',
	OnPreviewFabricSetSize	= 'TOOLS_PREVIEW_FABRIC_SET_SIZE',
	OnSetRepeatMode 		= 'TOOLS_SET_REPEAT_MODE',
	OnToggleRepeatMode 		= 'TOOLS_TOGGLE_REPEAT_MODE',
}

export const OnToggleGrid = () => createAction(ToolsActionType.OnToggleGrid)
export const OnToggleRulers = () => createAction(ToolsActionType.OnToggleRulers)
export const OnToggleOverlay = () => createAction(ToolsActionType.OnToggleOverlay)
export const OnCenterDocument = () => createAction(ToolsActionType.OnCenterDocument)
export const OnTogglePreviewFabric = () => createAction(ToolsActionType.OnTogglePreviewFabric)
export const OnPreviewFabricSetSize = (width: number, height: number) => createAction(ToolsActionType.OnPreviewFabricSetSize, {
	width: width,
	height: height
})
export const OnSetRepeatMode = (repeatMode: string) => createAction(ToolsActionType.OnSetRepeatMode, {
	repeatMode: repeatMode
})
export const OnToggleRepeatMode = () => createAction(ToolsActionType.OnToggleRepeatMode)

export type ToolsAction = 
	ReturnType<typeof OnToggleGrid> 			|
	ReturnType<typeof OnToggleRulers> 			|
	ReturnType<typeof OnToggleOverlay> 			|
	ReturnType<typeof OnCenterDocument> 		|
	ReturnType<typeof OnTogglePreviewFabric> 	|
	ReturnType<typeof OnPreviewFabricSetSize> 	|
	ReturnType<typeof OnSetRepeatMode> 			|
	ReturnType<typeof OnToggleRepeatMode>